//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
export interface AdminDiscountListDTO {
  id: string;
  translations: AdminDiscountTranslationDTO[];
}
export interface AdminDiscountTranslationDTO {
  language: LanguageCode;
  name: string;
}
export interface AdminEventCategoryGetDTO {
  status: StatusCode;
  translations: AdminEventCategoryTranslationPutDTO[];
  topics: Topic[];
  id: string;
  isReadOnly: boolean;
}
export interface AdminEventCategoryListDTO {
  id: string;
  name: string;
  topics: Topic[];
  eventCount: number;
  status: StatusCode;
  createdAt: Date;
  createdByName: string;
  updatedAt: Date;
  updatedByName: string;
  languages: LanguageCode[];
  isReadOnly: boolean;
}
export interface AdminEventCategoryPostPutDTO {
  status: StatusCode;
  translations: AdminEventCategoryTranslationPutDTO[];
  topics: Topic[];
}
export interface AdminEventCategoryTranslationPutDTO {
  language: LanguageCode;
  name: string;
}
export interface AdminEventGetDTO {
  categoryIds: string[];
  isHighlighted: boolean;
  from: Date;
  to: Date | null;
  status: StatusCode;
  isPublishNotificationEnabled: boolean;
  publishedFrom: Date;
  locationId: string | null;
  isWholeDay: boolean;
  translations: ContentTranslationPutDTO[];
  images: ImagePutDTO[];
  id: string;
  isExternal: boolean;
}
export interface AdminEventListDTO {
  id: string;
  title: string;
  categories: IdentifierDTOOfGuid[];
  isHighlighted: boolean;
  from: Date;
  to: Date | null;
  status: StatusCode;
  locationTitle: string | null;
  createdAt: Date;
  createdByName: string | null;
  updatedAt: Date;
  updatedByName: string | null;
  languages: LanguageCode[];
  isExternal: boolean;
}
export interface AdminEventPostPutDTO {
  categoryIds: string[];
  isHighlighted: boolean;
  from: Date;
  to: Date | null;
  status: StatusCode;
  isPublishNotificationEnabled: boolean;
  publishedFrom: Date;
  locationId: string | null;
  isWholeDay: boolean;
  translations: ContentTranslationPutDTO[];
  images: ImagePutDTO[];
}
export interface AdminLocationCategoryGetDTO {
  status: StatusCode;
  translations: AdminLocationCategoryTranslationPutDTO[];
  id: string;
}
export interface AdminLocationCategoryListDTO {
  id: string;
  name: string;
  locationCount: number;
  status: StatusCode;
  createdAt: Date;
  createdByName: string | null;
  updatedAt: Date;
  updatedByName: string | null;
  languages: LanguageCode[];
}
export interface AdminLocationCategoryPostPutDTO {
  status: StatusCode;
  translations: AdminLocationCategoryTranslationPutDTO[];
}
export interface AdminLocationCategoryTranslationPutDTO {
  language: LanguageCode;
  name: string;
}
export interface AdminLocationContactDTO {
  website: string | null;
  facebook: string | null;
  instagram: string | null;
  email: string | null;
  phone: string | null;
}
export interface AdminLocationGetDTO {
  id: string;
  categoryIds: string[];
  isHighlighted: boolean;
  status: StatusCode;
  contact: AdminLocationContactDTO;
  poiId: string | null;
  isUniversity: boolean;
  isPublishNotificationEnabled: boolean;
  translations: ContentTranslationGetDTO[];
  images: ImageGetDTO[];
}
export interface AdminLocationListDTO {
  id: string;
  title: string;
  categories: IdentifierDTOOfGuid[];
  status: StatusCode;
  poiAddress: string | null;
  createdAt: Date;
  createdByName: string;
  updatedAt: Date;
  updatedByName: string;
  languages: LanguageCode[];
  hasEvent: boolean;
  hasOffer: boolean;
}
export interface AdminLocationPostPutDTO {
  categoryIds: string[];
  isHighlighted: boolean;
  status: StatusCode;
  contact: AdminLocationContactDTO;
  poiId: string | null;
  isUniversity: boolean;
  isPublishNotificationEnabled: boolean;
  translations: ContentTranslationPutDTO[];
  images: ImagePutDTO[];
}
export interface AdminNewsCategoryGetDTO {
  status: StatusCode;
  translations: AdminNewsCategoryTranslationPutDTO[];
  topics: Topic[];
  id: string;
  newsIds: string[];
  isReadOnly: boolean;
}
export interface AdminNewsCategoryListDTO {
  id: string;
  name: string;
  topics: Topic[];
  newsCount: number;
  status: StatusCode;
  createdAt: Date;
  createdByName: string;
  updatedAt: Date;
  updatedByName: string;
  languages: LanguageCode[];
  isReadOnly: boolean;
}
export interface AdminNewsCategoryPostPutDTO {
  status: StatusCode;
  translations: AdminNewsCategoryTranslationPutDTO[];
  topics: Topic[];
}
export interface AdminNewsCategoryTranslationPutDTO {
  language: LanguageCode;
  name: string;
}
export interface AdminNewsGetDTO {
  id: string;
  categoryIds: string[];
  isHighlighted: boolean;
  publishedFrom: Date;
  publishedTo: Date | null;
  status: StatusCode;
  isPublishNotificationEnabled: boolean;
  createdAt: Date;
  createdById: string | null;
  updatedAt: Date;
  updatedById: string | null;
  translations: ContentTranslationGetDTO[];
  images: ImageGetDTO[];
  isExternal: boolean;
}
export interface AdminNewsListDTO {
  id: string;
  title: string;
  categories: IdentifierDTOOfGuid[];
  isHighlighted: boolean;
  publishedFrom: Date;
  publishedTo: Date | null;
  status: StatusCode;
  createdAt: Date;
  createdByName: string | null;
  updatedAt: Date;
  updatedByName: string | null;
  languages: LanguageCode[];
  isExternal: boolean;
}
export interface AdminNewsPostPutDTO {
  categoryIds: string[];
  isHighlighted: boolean;
  publishedFrom: Date;
  publishedTo: Date | null;
  status: StatusCode;
  isPublishNotificationEnabled: boolean;
  translations: ContentTranslationPutDTO[];
  images: ImagePutDTO[];
}
export interface AdminOfferCategoryGetDTO {
  status: StatusCode;
  translations: AdminOfferCategoryTranslationPutDTO[];
  id: string;
}
export interface AdminOfferCategoryListDTO {
  id: string;
  name: string;
  offerCount: number;
  status: StatusCode;
  createdAt: Date;
  createdByName: string;
  updatedAt: Date;
  updatedByName: string;
  languages: LanguageCode[];
}
export interface AdminOfferCategoryPostPutDTO {
  status: StatusCode;
  translations: AdminOfferCategoryTranslationPutDTO[];
}
export interface AdminOfferCategoryTranslationPutDTO {
  language: LanguageCode;
  name: string;
}
export interface AdminOfferGetDTO {
  id: string;
  discountId: string;
  locationId: string;
  from: Date;
  to: Date | null;
  categoryIds: string[];
  status: StatusCode;
  isHighlighted: boolean;
  publishedFrom: Date;
  isPublishNotificationEnabled: boolean;
  translations: ContentTranslationGetDTO[];
  images: ImageGetDTO[];
}
export interface AdminOfferListDTO {
  id: string;
  title: string;
  discountName: string;
  from: Date;
  to: Date | null;
  isHighlighted: boolean;
  categories: IdentifierDTOOfGuid[];
  status: StatusCode;
  locationTitle: string;
  createdAt: Date;
  createdByName: string;
  updatedAt: Date;
  updatedByName: string;
  languages: LanguageCode[];
}
export interface AdminOfferPostPutDTO {
  categoryIds: string[];
  isHighlighted: boolean;
  from: Date;
  to: Date | null;
  status: StatusCode;
  isPublishNotificationEnabled: boolean;
  publishedFrom: Date;
  locationId: string;
  discountId: string;
  translations: ContentTranslationPutDTO[];
  images: ImagePutDTO[];
}
export interface AdminOnboardingStepGetDTO {
  id: string;
  order: number;
  image: ImageGetDTO;
  translations: AdminOnboardingStepTranslationGetDTO[];
}
export interface AdminOnboardingStepListDTO {
  id: string;
  title: string;
  order: number;
  languages: LanguageCode[];
  createdAt: Date;
  createdByName: string;
  updatedAt: Date;
  updatedByName: string;
}
export interface AdminOnboardingStepPostPutDTO {
  order: number;
  image: ImagePutDTO;
  translations: AdminOnboardingStepTranslationPostPutDTO[];
}
export interface AdminOnboardingStepTranslationGetDTO {
  language: LanguageCode;
  title: string;
  content: string;
}
export interface AdminOnboardingStepTranslationPostPutDTO {
  language: LanguageCode;
  title: string;
  content: string;
}
export interface AdminPointOfInterestGetDTO {
  id: string;
  address: string;
  latitude: number;
  longitude: number;
}
export interface AdminPointOfInterestListDTO {
  id: string;
  address: string;
  latitude: number;
  longitude: number;
  createdAt: Date;
  createdByName: string;
  updatedAt: Date;
  updatedByName: string;
  locationCount: number;
}
export interface AdminPointOfInterestPostPutDTO {
  address: string;
  latitude: number;
  longitude: number;
}
export interface AdminResourceGetDTO {
  id: string;
  name: string;
  locationId: string;
  email: string;
  availableFrom: string;
  availableTo: string;
  weeklyOpeningHours: WeeklyOpeningHourGetDTO[];
}
export interface AdminResourceListDTO {
  id: string;
  name: string;
  email: string;
  locationTitle: string;
  availableFrom: string;
  availableTo: string;
  createdAt: Date;
  createdByName: string;
  updatedAt: Date;
  updatedByName: string;
}
export interface AdminResourcePostPutDTO {
  email: string;
  name: string;
  locationId: string;
  availableFrom: string;
  availableTo: string;
  weeklyOpeningHours: WeeklyOpeningHourPostPutDTO[];
}
export interface AdminResourceReservationListDTO {
  resourceName: string;
  from: Date;
  to: Date;
  reservedByPrintName: string;
  reservedByEmail: string;
  reservedByPhone: string | null;
  topic: ResourceReservationTopic;
  comment: string | null;
  createdAt: Date;
}
export interface AdminUserGetDTO {
  id: string;
  email: string;
  name: string;
  role: AdminUserRole;
}
export interface AdminUserListDTO {
  id: string;
  email: string;
  name: string;
  role: AdminUserRole;
  status: AdminUserStatus;
  createdAt: Date;
}
export interface AdminUserProfileGetDTO {
  email: string;
  name: string;
  role: AdminUserRole;
}
export interface AdminUserProfilePutDTO {
  name: string;
}
export interface AdminUserPutDTO {
  name: string;
  role: AdminUserRole;
}
export interface AppointmentDTO {
  from: Date;
  to: Date;
}
export interface AuthAdminUserGetDTO {
  id: string;
  name: string;
  role: AdminUserRole;
}
export interface AuthUserGetDTO {
  id: string;
  avatarId: string;
  language: LanguageCode;
  isOnboardingRequired: boolean;
  externalId: string;
  nickname: string;
}
export interface BootstrapPostDTO {
  firstAdminUserEmail: string;
  firstAdminUserName: string;
}
export interface BootstrapResponseDTO {
  message: string;
}
export interface CalendarEntryGetDTO {
  id: string;
  type: CalendarEntryType;
  name: string;
  from: Date;
  to: Date;
  room: RoomGetDTO;
  professorNames: string[];
}
export interface CalendarEntryListDTO {
  calendarEntries: CalendarEntryGetDTO[];
}
export interface CardGetDTO {
  code: string | null;
  userPrintName: string | null;
}
export interface ContentTranslationGetDTO {
  language: LanguageCode;
  title: string;
  shortDescription: string;
  content: string;
  coverImage: CoverImageGetDTO;
  labels: string[];
  ctaUrl: string | null;
  ctaText: string | null;
}
export interface ContentTranslationPutDTO {
  language: LanguageCode;
  title: string;
  shortDescription: string;
  content: string;
  coverImage: CoverImagePutDTO;
  labels: string[];
  ctaUrl: string | null;
  ctaText: string | null;
}
export interface CoverImageGetDTO {
  id: string;
  subtitle: string;
}
export interface CoverImagePutDTO {
  id: string;
  subtitle: string;
}
export interface DirectionsDTO {
  distance: string;
  duration: string;
  polyLine: string;
  status: MapsResponseStatus;
  errorMessage: string | null;
}
export interface ForbiddenNicknameGetDTO {
  id: string;
  value: string;
}
export type ForbiddenNicknameOrderByColumn = 'value';
export interface ForbiddenNicknamePostDTO {
  value: string;
}
export interface GeocodingResult {
  geometry: Geometry;
}
export interface GeofenceFilterDTO {
  latitude: number;
  longitude: number;
}
export interface GeofenceListDTO {
  id: string;
  latitude: number;
  longitude: number;
  range: number;
}
export interface Geometry {
  location: Location;
}
export interface IdentifierDTOOfGuid {
  id: string;
  name: string;
}
export interface ImageGetDTO {
  id: string;
  translations: ImageTranslationGetDTO[];
}
export interface ImagePutDTO {
  id: string;
  translations: ImageTranslationPutDTO[];
}
export interface ImageTranslationGetDTO {
  language: LanguageCode;
  subtitle: string;
}
export interface ImageTranslationPutDTO {
  language: LanguageCode;
  subtitle: string;
}
export interface IntegrationEventGetDTO {
  id: string;
  translations: TitleTranslationDTO[];
  locationTranslations: TitleTranslationDTO[];
  categoriesFavouritedByUserIds: string[];
}
export interface IntegrationLocationGetDTO {
  id: string;
  languages: LanguageCode[];
}
export interface IntegrationOfferGetDTO {
  id: string;
  translations: TitleTranslationDTO[];
  locationTranslations: TitleTranslationDTO[];
  categoriesFavouritedByUserIds: string[];
  locationFavouritedByUserIds: string[];
}
export interface InvitationFlowStartDTO {
  name: string;
  role: AdminUserRole;
  email: string;
}
export interface Location {
  lat: number;
  lng: number;
}
export interface LocationContactGetDTO {
  phone: string | null;
  email: string | null;
  websiteUrl: string | null;
  facebookUrl: string | null;
  instagramUrl: string | null;
}
export interface MGLIntegrationEventPostPutDTO {
  categories: string[];
  isHighlighted: boolean;
  publishedFrom: Date;
  from: Date;
  to: Date | null;
  translation: ContentTranslationPutDTO;
}
export interface MGLIntegrationNewsPostPutDTO {
  categories: string[];
  isHighlighted: boolean;
  publishedFrom: Date;
  translation: ContentTranslationPutDTO;
}
export interface MobileEventCategoryListDTO {
  id: string;
  name: string;
  isFavourite: boolean;
}
export interface MobileEventGetDTO {
  id: string;
  title: string;
  coverImage: CoverImageGetDTO;
  shortDescription: string;
  content: string;
  from: Date;
  to: Date | null;
  ctaUrl: string | null;
  ctaText: string | null;
  images: MobileImageGetDTO[];
  categories: IdentifierDTOOfGuid[];
  location: MobileLocationBasicDTO;
  isFavourite: boolean;
  topics: Topic[];
}
export interface MobileEventListDTO {
  id: string;
  isHighlighted: boolean;
  from: Date;
  to: Date | null;
  title: string;
  coverImage: CoverImageGetDTO;
  locationTitle: string | null;
}
export type MobileEventOrderByColumn = 'from';
export interface MobileImageGetDTO {
  id: string;
  order: number;
  subtitle: string;
}
export interface MobileLocationBasicDTO {
  id: string;
  title: string | null;
  poiAddress: string | null;
}
export interface MobileLocationCategoryListDTO {
  id: string;
  name: string;
  isFavourite: boolean;
}
export interface MobileLocationGetDTO {
  id: string;
  title: string;
  shortDescription: string;
  content: string;
  ctaUrl: string | null;
  ctaText: string | null;
  isFavourite: boolean;
  poi: MobilePointOfInterestListDTO;
  locationContact: LocationContactGetDTO;
  images: MobileImageGetDTO[];
  categories: IdentifierDTOOfGuid[];
  coverImage: CoverImageGetDTO;
}
export interface MobileLocationListDTO {
  id: string;
  title: string;
  poi: MobilePointOfInterestListDTO;
  coverImage: CoverImageGetDTO;
}
export interface MobileNewsCategoryListDTO {
  id: string;
  name: string;
  isFavourite: boolean;
}
export interface MobileNewsGetDTO {
  id: string;
  coverImage: CoverImageGetDTO;
  title: string;
  shortDescription: string;
  content: string;
  publishedFrom: Date;
  ctaUrl: string | null;
  ctaText: string | null;
  images: MobileImageGetDTO[];
  categories: IdentifierDTOOfGuid[];
  topics: Topic[];
}
export interface MobileNewsListDTO {
  id: string;
  coverImage: CoverImageGetDTO;
  title: string;
  publishedFrom: Date;
  isHighlighted: boolean;
}
export interface MobileOfferCategoryListDTO {
  id: string;
  name: string;
  isFavourite: boolean;
}
export interface MobileOfferGetDTO {
  id: string;
  discount: string;
  from: Date;
  to: Date | null;
  shortDescription: string;
  content: string;
  title: string;
  isFavourite: boolean;
  ctaUrl: string | null;
  ctaText: string | null;
  coverImage: CoverImageGetDTO;
  location: MobileLocationBasicDTO;
  categories: IdentifierDTOOfGuid[];
  images: MobileImageGetDTO[];
}
export interface MobileOfferListDTO {
  id: string;
  discount: string;
  isHighlighted: boolean;
  from: Date;
  to: Date | null;
  title: string;
  coverImage: CoverImageGetDTO;
  locationTitle: string;
}
export interface MobileOnboardingStepDTO {
  image: OnboardingStepImageGetDTO;
  title: string;
  content: string;
}
export interface MobileOnboardingStepListDTO {
  isCompleted: boolean;
  steps: MobileOnboardingStepDTO[];
}
export interface MobilePointOfInterestListDTO {
  address: string;
  latitude: number;
  longitude: number;
}
export interface MobileResourceGetDTO {
  id: string;
  name: string;
  locationTitle: string;
  locationAddress: string | null;
  email: string;
  appointments: AppointmentDTO[];
}
export interface MobileResourceReservationListDTO {
  id: string;
  from: Date;
  to: Date;
  topic: ResourceReservationTopic;
  resource: ResourceReservationResourceDTO;
}
export interface NotificationIntegrationNewsGetDTO {
  id: string;
  translations: TitleTranslationDTO[];
  categoriesFavouritedByUserIds: string[];
}
export interface OnboardingStepImageGetDTO {
  id: string;
  subtitle: string;
}
export interface PaginatedDTOOfAdminDiscountListDTO {
  data: AdminDiscountListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminEventCategoryListDTO {
  data: AdminEventCategoryListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminEventListDTO {
  data: AdminEventListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminLocationCategoryListDTO {
  data: AdminLocationCategoryListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminLocationListDTO {
  data: AdminLocationListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminNewsCategoryListDTO {
  data: AdminNewsCategoryListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminNewsListDTO {
  data: AdminNewsListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminOfferCategoryListDTO {
  data: AdminOfferCategoryListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminOfferListDTO {
  data: AdminOfferListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminOnboardingStepListDTO {
  data: AdminOnboardingStepListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminPointOfInterestListDTO {
  data: AdminPointOfInterestListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminResourceListDTO {
  data: AdminResourceListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminResourceReservationListDTO {
  data: AdminResourceReservationListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfAdminUserListDTO {
  data: AdminUserListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfForbiddenNicknameGetDTO {
  data: ForbiddenNicknameGetDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfIdentifierDTOOfGuid {
  data: IdentifierDTOOfGuid[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfMobileEventListDTO {
  data: MobileEventListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfMobileNewsListDTO {
  data: MobileNewsListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfMobileOfferListDTO {
  data: MobileOfferListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfMobileResourceReservationListDTO {
  data: MobileResourceReservationListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfQueryTopicContentListDTO {
  data: QueryTopicContentListDTO[];
  pagination: PaginationDTO;
}
export interface PaginatedDTOOfResourceOpeningHourExclusionListDTO {
  data: ResourceOpeningHourExclusionListDTO[];
  pagination: PaginationDTO;
}
export interface PaginationDTO {
  totalCount: number;
}
export interface PositionDTO {
  start: WayPointDTO;
  end: WayPointDTO;
  language: LanguageCode;
}
export interface QueryTopicContentListDTO {
  id: string;
  coverImage: CoverImageGetDTO;
  title: string;
  shortDescription: string;
  address: string | null;
  from: Date;
  isHighlighted: boolean;
  isFavourite: boolean;
  contentType: QueryTopicContentType;
}
export interface ResourceOpeningHourExclusionGetDTO {
  id: string;
  from: string;
  to: string;
  resources: IdentifierDTOOfGuid[];
}
export interface ResourceOpeningHourExclusionListDTO {
  id: string;
  from: string;
  to: string;
  createdAt: Date;
  createdByName: string;
  updatedAt: Date;
  updatedByName: string;
  resources: IdentifierDTOOfGuid[];
}
export interface ResourceOpeningHourExclusionPostPutDTO {
  from: string;
  to: string;
  resourceIds: string[];
}
export interface ResourceReservationPostDTO {
  from: Date;
  to: Date;
  topic: ResourceReservationTopic;
  comment: string | null;
  reservedByEmail: string;
  reservedByPhone: string | null;
}
export interface ResourceReservationResourceDTO {
  name: string;
  locationTitle: string;
  locationAddress: string | null;
  locationId: string;
  email: string;
}
export interface RoomGetDTO {
  name: string;
  code: string | null;
  latitude: number | null;
  longitude: number | null;
}
export interface TitleTranslationDTO {
  language: LanguageCode;
  title: string;
}
export interface UserAttributeSearchDTO {
  filters: UserAttributeTypeSearchDTO[];
}
export interface UserAttributeTypeSearchDTO {
  type: AudienceType;
  ids: string[];
}
export interface UserFavouriteCategoryGetDTO {
  newsCategories: MobileNewsCategoryListDTO[];
  eventCategories: MobileEventCategoryListDTO[];
  offerCategories: MobileOfferCategoryListDTO[];
  locationCategories: MobileLocationCategoryListDTO[];
}
export interface UserFavouriteCategoryPutDTO {
  newsCategoryIds: string[];
  eventCategoryIds: string[];
  offerCategoryIds: string[];
  locationCategoryIds: string[];
}
export interface UserFavouriteEventPutDTO {
  id: string;
  isFavourite: boolean;
}
export interface UserFavouriteLocationPutDTO {
  id: string;
  isFavourite: boolean;
}
export interface UserFavouriteOfferPutDTO {
  id: string;
  isFavourite: boolean;
}
export interface UserGetDTO {
  nickname: string;
  avatarId: string;
}
export interface UserLanguageDTO {
  language: LanguageCode;
}
export interface UserOnboardingDTO {
  isOnboardingFinished: boolean;
}
export interface UserPostDTO {
  nickname: string;
  avatarId: string;
  language: LanguageCode;
}
export interface UserPutDTO {
  nickname: string;
  avatarId: string;
}
export interface UserTrainingListDTO {
  name: string;
  levelName: string;
  semesterName: string;
  enrolledCreditQuantity: number;
  completedCreditQuantity: number;
  readonly creditCompletionRate: number;
  subjects: UserTrainingSubjectGetDTO[];
}
export interface UserTrainingSubjectGetDTO {
  name: string;
  credits: number;
  isCompleted: boolean;
}
export interface WayPointDTO {
  latitude: number;
  longitude: number;
}
export interface WeeklyOpeningHourGetDTO {
  day: DayOfWeek;
  from: string | null;
  to: string | null;
  isClosed: boolean;
}
export interface WeeklyOpeningHourPostPutDTO {
  day: DayOfWeek;
  from: string | null;
  to: string | null;
}
export const AdminEventCategoryOrderByColumns = [
  'name',
  'createdAt',
  'createdByName',
  'updatedAt',
  'updatedByName',
  'eventCount',
] as const;
export type AdminEventCategoryOrderByColumn = (typeof AdminEventCategoryOrderByColumns)[number];
export const AdminEventOrderByColumns = [
  'title',
  'locationTitle',
  'createdAt',
  'createdByName',
  'updatedAt',
  'updatedByName',
  'from',
  'to',
] as const;
export type AdminEventOrderByColumn = (typeof AdminEventOrderByColumns)[number];
export const AdminLocationCategoryOrderByColumns = [
  'name',
  'createdAt',
  'createdByName',
  'updatedAt',
  'updatedByName',
  'locationCount',
] as const;
export type AdminLocationCategoryOrderByColumn =
  (typeof AdminLocationCategoryOrderByColumns)[number];
export const AdminLocationOrderByColumns = [
  'title',
  'poiAddress',
  'createdAt',
  'createdByName',
  'updatedAt',
  'updatedByName',
] as const;
export type AdminLocationOrderByColumn = (typeof AdminLocationOrderByColumns)[number];
export const AdminNewsCategoryOrderByColumns = [
  'name',
  'createdAt',
  'createdByName',
  'updatedAt',
  'updatedByName',
  'newsCount',
] as const;
export type AdminNewsCategoryOrderByColumn = (typeof AdminNewsCategoryOrderByColumns)[number];
export const AdminNewsOrderByColumns = [
  'title',
  'createdAt',
  'createdByName',
  'updatedAt',
  'updatedByName',
  'publishedFrom',
  'publishedTo',
] as const;
export type AdminNewsOrderByColumn = (typeof AdminNewsOrderByColumns)[number];
export const AdminOfferCategoryOrderByColumns = [
  'name',
  'createdAt',
  'createdByName',
  'updatedAt',
  'updatedByName',
  'offerCount',
] as const;
export type AdminOfferCategoryOrderByColumn = (typeof AdminOfferCategoryOrderByColumns)[number];
export const AdminOfferOrderByColumns = [
  'title',
  'discountName',
  'locationTitle',
  'createdAt',
  'createdByName',
  'updatedAt',
  'updatedByName',
  'from',
  'to',
] as const;
export type AdminOfferOrderByColumn = (typeof AdminOfferOrderByColumns)[number];
export const AdminOnboardingStepOrderByColumns = [
  'title',
  'order',
  'createdAt',
  'createdByName',
  'updatedAt',
  'updatedByName',
] as const;
export type AdminOnboardingStepOrderByColumn = (typeof AdminOnboardingStepOrderByColumns)[number];
export const AdminPointOfInterestOrderByColumns = [
  'address',
  'createdAt',
  'createdByName',
  'updatedAt',
  'updatedByName',
  'locationCount',
] as const;
export type AdminPointOfInterestOrderByColumn = (typeof AdminPointOfInterestOrderByColumns)[number];
export const AdminResourceReservationOrderByColumns = [
  'resourceName',
  'from',
  'to',
  'createdAt',
] as const;
export type AdminResourceReservationOrderByColumn =
  (typeof AdminResourceReservationOrderByColumns)[number];
export const AdminUserOrderByColumns = ['email', 'name', 'createdAt'] as const;
export type AdminUserOrderByColumn = (typeof AdminUserOrderByColumns)[number];
export const AdminUserRoles = ['SystemAdmin', 'Admin'] as const;
export type AdminUserRole = (typeof AdminUserRoles)[number];
export const AdminUserStatuses = ['Invited', 'Active', 'Blocked', 'Deleted'] as const;
export type AdminUserStatus = (typeof AdminUserStatuses)[number];
export const AudienceTypes = [
  'PlaceOfBirth',
  'Nationality',
  'Country',
  'County',
  'City',
  'TrainingStatus',
  'FinancialStatus',
  'SemesterStatus',
  'TrainingDepartment',
  'TrainingLevel',
  'TrainingField',
  'Faculty',
] as const;
export type AudienceType = (typeof AudienceTypes)[number];
export const CalendarEntryTypes = ['Exam', 'Course'] as const;
export type CalendarEntryType = (typeof CalendarEntryTypes)[number];
export const DayOfWeeks = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const;
export type DayOfWeek = (typeof DayOfWeeks)[number];
export const LanguageCodes = ['hu', 'en'] as const;
export type LanguageCode = (typeof LanguageCodes)[number];
export const LocationTypes = ['Offer', 'University'] as const;
export type LocationType = (typeof LocationTypes)[number];
export const MapsResponseStatuses = [
  'OK',
  'NOT_FOUND',
  'ZERO_RESULTS',
  'OVER_DAILY_LIMIT',
  'OVER_QUERY_LIMIT',
  'REQUEST_DENIED',
  'INVALID_REQUEST',
  'UNKNOWN_ERROR',
] as const;
export type MapsResponseStatus = (typeof MapsResponseStatuses)[number];
export const MobileLocationOrderByColumns = ['isHighlighted', 'title'] as const;
export type MobileLocationOrderByColumn = (typeof MobileLocationOrderByColumns)[number];
export const MobileOfferOrderByColumns = ['title', 'from'] as const;
export type MobileOfferOrderByColumn = (typeof MobileOfferOrderByColumns)[number];
export const NewsOrderByColumns = ['title', 'publishedFrom'] as const;
export type NewsOrderByColumn = (typeof NewsOrderByColumns)[number];
export const OrderByDirections = ['asc', 'desc'] as const;
export type OrderByDirection = (typeof OrderByDirections)[number];
export const QueryTopicContentTypes = ['News', 'Event'] as const;
export type QueryTopicContentType = (typeof QueryTopicContentTypes)[number];
export const ResourceReservationTopics = [
  'AcademicIssues',
  'WelfareIssues',
  'Scholarships',
  'DormitoryIssues',
  'StudentEventsAndPrograms',
  'UniversityTraditionsAndCeremonies',
  'StudentRepresentationAndMembership',
  'Other',
] as const;
export type ResourceReservationTopic = (typeof ResourceReservationTopics)[number];
export const StatusCodes = ['Active', 'Inactive'] as const;
export type StatusCode = (typeof StatusCodes)[number];
export const Topics = ['Education', 'UniversityLife', 'CampusNews', 'UniRadar'] as const;
export type Topic = (typeof Topics)[number];
